import { render, staticRenderFns } from "./DashboardDonePlanItems.vue?vue&type=template&id=a74d7e14"
import script from "./DashboardDonePlanItems.vue?vue&type=script&lang=ts"
export * from "./DashboardDonePlanItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports